export default (node) => {
  const ROLL_HEIGHT = 1005; // cm
  const ROLL_WIDTH = 53; // cm

  const heightInput = node.querySelector('[data-wallpaper-height]');
  const widthInput = node.querySelector('[data-wallpaper-width]');
  const resultElement = node.querySelector('[data-wallpaper-result]');
  const quantityInput = document.querySelector('[data-quantity]');

  // Early return if required elements don't exist
  if (!heightInput || !widthInput || !resultElement) {
    return;
  }

  const answerFirst = node.dataset.answerFirst;
  const answerLastSingular = node.dataset.answerLastSingular;
  const answerLastPlural = node.dataset.answerLastPlural;

  let debounceTimer;

  const validateNumericInput = (event) => {
    const input = event.target;
    const value = input.value;
    const validValue = value.replace(/[^0-9]/g, '');

    if (validValue !== value) {
      // Restore cursor position
      const cursorPosition = input.selectionStart - 1;
      input.value = validValue;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }
  };

  const calculate = () => {
    let height = parseFloat(heightInput.value);
    let width = parseFloat(widthInput.value);

    if (!height || !width || height <= 0 || width <= 0) {
      resultElement.textContent = '';
      return;
    }

    const lanesPerRoll = Math.floor(ROLL_HEIGHT / height);
    const lanes = width / ROLL_WIDTH;
    const total = Math.ceil(lanes / lanesPerRoll);

    const answer = `${answerFirst} ${total} ${total === 1 ? answerLastSingular : answerLastPlural}`;

    // Add smooth transition for result
    resultElement.style.opacity = '0';
    setTimeout(() => {
      resultElement.textContent = answer;
      resultElement.style.opacity = '1';
    }, 150);

    // Update quantity selector if it exists and total is valid
    if (quantityInput && isFinite(total) && total > 0) {
      quantityInput.value = total;
    }
  };

  const debouncedCalculate = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(calculate, 300);
  };

  const init = () => {
    // Add transition style to result element
    resultElement.style.transition = 'opacity 0.3s ease-in-out';

    heightInput.addEventListener('input', validateNumericInput);
    widthInput.addEventListener('input', validateNumericInput);

    // Auto-calculate on input change (debounced)
    heightInput.addEventListener('input', debouncedCalculate);
    widthInput.addEventListener('input', debouncedCalculate);
  };

  init();
};
